import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';

export type MetricDataPoint = {
  label: string;
  value: number;
};

type Props = {
  data: MetricDataPoint[];
  title?: string;
  color?: string;
  height?: number;
};

export function MetricTrendChart({ data, title, color = '#171717', height = 220 }: Props) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center text-stone-400 text-sm" style={{ height }}>
        No metric data available
      </div>
    );
  }

  return (
    <div>
      {title && <p className="text-xs font-medium text-stone-500 mb-2 uppercase tracking-wide">{title}</p>}
      {/* Fixed width avoids ResponsiveContainer's ResizeObserver — see Box9QuadrantChart for rationale */}
      <div style={{ width: '100%', height, overflow: 'hidden' }}>
        <LineChart width={800} height={height} data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}
          style={{ width: '100%', maxWidth: '100%' }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e7e5e4" />
          <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#78716c' }} />
          <YAxis tick={{ fontSize: 11, fill: '#78716c' }} />
          <Tooltip
            contentStyle={{ fontSize: 12, borderRadius: 4, border: '1px solid #e7e5e4' }}
          />
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={2}
            dot={{ r: 3, fill: color }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </div>
    </div>
  );
}
